export const SkeletonColors = {
	startColor: 'blue.50',
	endColor: 'dropBlue',
};
